export default __webpack_public_path__ + "alberta-scan.4e63d1be5b872467f35a.svg";